import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";

import { logout } from "../../redux/auth/actions";
import { setFailedActiveKeyRequest } from "../../redux/applicant/actions";
import { Sidebar } from "../../components/organisms/Sidebar";
import { Modal } from "../../components/organisms/Modal";
import { BodyWrapper, ModalButtonsWrapper, LogoutContent } from "./styles";
import { Button } from "../../components/atoms/Button";
import { updateCurrentUserRequest } from "../../redux/user/action";
import { User } from "../../core/entities/user";
import { fetchNotificationsCount } from './../../redux/notification/actions';
import { clearSpecificRequest } from "../../redux/request/action";
import { FETCH_NOTIFICATION_COUNT_REQUEST } from "../../redux/notification/actionType";
import { onNotificationListener } from "../../firebase";

const SidebarWithHooks = (props: any) => {
  const {
    toggleSideNav,
    showHideSidenav,
    defaultSelectedKey,
    user,
    currentSubmenu
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const dispatchLogout = useCallback(() => dispatch(logout()), [dispatch]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const notificationsCount = useSelector(
    (state: RootStateOrAny) => state.notification.count,
  );

  const dispatchUpdateUser = useCallback(
    (id: string, params: Partial<User>) =>
      dispatch(updateCurrentUserRequest(id, params, "basicDetails")),
    [dispatch]
  );

  const setFailedActiveKey = (key: string) => {
    dispatch(setFailedActiveKeyRequest(key));
  };

  const handleClickLogout = () => {
    dispatchUpdateUser(user.id, { registrationToken: "" });
    dispatchLogout();

    return history.push("/login");
  };

  const dispatchFetchNotificationsCountHandler = () => {
    dispatch(fetchNotificationsCount(
      (user.isAdmin || user.isSuperAdmin),
      [
        ["user.id", "!=", user.id],
        ["read", "==", false],
        ["type", "in", (user.isAdmin || user.isSuperAdmin) ? ["move", "commented", "schedule", "summary"] : ['commented', 'move', 'schedule', 'summary', 'applied', 'end', 'response', 'emailResponse']]
      ]))
  }

  useEffect(() => {
    const unsubscribe = onNotificationListener(dispatchFetchNotificationsCountHandler);
    return () => {
      unsubscribe(); 
      clearSpecificRequest(FETCH_NOTIFICATION_COUNT_REQUEST);
    };
  }, [dispatch, user]);

  const handleClick = (e: any) => {
    toggleSideNav();
    setFailedActiveKey("");
    const key = e.key;

    switch (key) {
      case "/recruit/logout":
        return setIsModalOpen(true);
      case "/recruit/new-applicants":
        return history.push("/recruit/new-applicants");
      case "/recruit/shortlisted":
        return history.push("/recruit/shortlisted");
      case "/recruit/technical-exam":
        return history.push("/recruit/technical-exam");
      case "/recruit/initial-interview":
        return history.push("/recruit/initial-interview");
      case "/recruit/psychological-exam":
        return history.push("/recruit/psychological-exam");
      case "/recruit/final-interview":
        return history.push("/recruit/final-interview");
      case "/recruit/job-offer":
        return history.push("/recruit/job-offer");
      case "/recruit/my-account":
        return history.push("/recruit/my-account");
      case "/recruit/failed":
        return history.push("/recruit/failed");
      case "/admin/users":
        return history.push("/admin/users");
      case "/admin/positions":
        return history.push("/admin/positions");
      case "/admin/notifications":
        return history.push("/admin/notifications");
      case "/recruit/search-applicants":
        return history.push("/recruit/search-applicants");
      case "/recruit/insights":
        return history.push("/recruit/insights");
      case "/recruit/applicants-database":
        return history.push("/recruit/applicants-database");
      case "/recruit/my-schedule":
        return history.push("/recruit/my-schedule");
      default:
        break;
    }
  };

  return (
    <>
      <Sidebar
        currentSubmenu={currentSubmenu}
        user={user}
        handleClick={handleClick}
        toggleSideNav={toggleSideNav}
        showHideSidenav={showHideSidenav}
        defaultSelectedKey={defaultSelectedKey}
        notificationCount={notificationsCount}
      />
      <Modal
        visible={isModalOpen}
        title="Logout"
        body={
          <div>
            <LogoutContent>Are you sure you want to logout?</LogoutContent>
            <BodyWrapper>
              <ModalButtonsWrapper>
                <Button
                  type="primary"
                  id="cancel_btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  No
                </Button>
                <Button type="primary" onClick={handleClickLogout}>
                  Yes
                </Button>
              </ModalButtonsWrapper>
            </BodyWrapper>
          </div>
        }
        onModalClose={() => setIsModalOpen(false)}
        width="650px"
      />
    </>
  );
};

export default SidebarWithHooks;
